module.exports = __webpack_public_path__ + "img/chinesecompany43.46f5ced8.png";